import React, { useState } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import Icon from '../../controls/icon/icon';
import "./authAside.scss";
import {ReactComponent as FlagUy} from 'itd-common/assets/icons/flag-uyu.svg';
import {ReactComponent as FlagArg} from 'itd-common/assets/icons/flag-arg.svg'

const T_PREFIX: string = 'pages.authAside.';

const AuthAside: React.FC = () => {
    const { t } = useTranslation();
    const [hiddenSelectCountry, sethiddenSelectCountry] = useState<Boolean>(false); 

    return (
        <div className="platform-section" style={{ maxWidth: `23rem`  }}>
            <div className="row">
                <div className="col-md-12">
                    <h1 className="platform-title">
                        <span>{t(`${T_PREFIX}default.title`)}</span> {t(`${T_PREFIX}default.subtitle`)}
                    </h1>

                </div>
                <div className="col-md-12">
                    <div className="platform-step">
                        <span className="material-symbols-outlined icon"><Icon name="account_balance_wallet" /></span>
                        <div>
                            <h3>{t(`${T_PREFIX}default.section.title`)}</h3>
                            <p>{t(`${T_PREFIX}default.section.description`)}</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="platform-step">
                        <span className="material-symbols-outlined icon"><Icon name="lab_profile"  /></span>
                        <div>
                            <h3>{t(`${T_PREFIX}default.section2.title`)}</h3>
                            <p>{t(`${T_PREFIX}default.section2.description`)}</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="platform-step">
                        <span className="material-symbols-outlined icon"><Icon name="bar_chart_4_bars"  /></span>
                        <div>
                            <h3>{t(`${T_PREFIX}default.section3.title`)}</h3>
                            <p>{t(`${T_PREFIX}default.section3.description`)}</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                <div >
                    
                    <div className="d-flex align-items-center">
                        <div>
                            <a onClick={() => sethiddenSelectCountry(!hiddenSelectCountry)} className="button v-primary content d-flex d-aling-items-center divCountry cursor-pointer">
                            {t(`${T_PREFIX}default.learnMore`)} <span className="material-symbols-outlined ms-2"><Icon name="arrow_right_alt"/></span>
                            </a>
                        </div>
                        <div className={`selectCountry ${!hiddenSelectCountry ? "hidden" : ""}`}>
                            <a href='https://www.fiserv.com.uy/' target='_blank' rel="noopener noreferrer">
                                <span className='pe-2'>{<FlagUy />}</span>
                            </a>
                            <a href='https://www.fiserv.com.ar/' target='_blank' rel="noopener noreferrer">
                                <span>{<FlagArg />}</span>
                            </a>
                        </div>
                    </div>
                </div> 
                </div>
            </div>
        </div>
    );
};

export default (AuthAside);